import * as cx from 'classnames';
import * as React from 'react';
import { ChangeEvent, FocusEvent, Fragment, KeyboardEvent } from 'react';
import { FieldMessage } from '..';
import * as Styles from './TextInput.scss';

interface IOwnProps {
  id: string;
  type: 'text' | 'password' | 'hidden' | 'tel' | 'email' | 'number';
  label?: string;
  name?: string;
  sizeVariant?: 'large' | 'medium' | 'half' | 'small';
  variant?: 'simple';
  value: any;
  required?: boolean;
  autoFocus?: boolean;
  disabled?: boolean;
  autoComplete?: string;
  errors?: {};
  touched?: any;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  onKeyPress?: (event: KeyboardEvent<HTMLInputElement>) => void;
  submitOnEnter?: boolean;
  successMessage?: string;
  hint?: string;
  placeholder?: string;
  readOnly?: boolean;
  appendIcon?: string;
  iconTitle?: string;
  onAppendIconClick?: () => void;
}
const TextInput: React.SFC<IOwnProps> = (props) => {
  const {
    id,
    label,
    sizeVariant,
    variant,
    value,
    readOnly,
    disabled,
    placeholder,
    required,
    onKeyPress,
    touched,
    errors,
    submitOnEnter,
    appendIcon,
    onAppendIconClick,
    iconTitle,
    ...restProps
  } = props;

  const componentClassNames = cx({ // TODO - probably better will be build wrapper for component (same style used for DropDown)
    [Styles.component]: true,
    [Styles.floatingLabel]: value !== '',
    [Styles.small]: !readOnly && sizeVariant === 'small',
    [Styles.medium]: !readOnly && sizeVariant === 'medium',
    [Styles.half]: !readOnly && sizeVariant === 'half',
    [Styles.simple]: !readOnly && variant === 'simple',
  });

  const textInputClassNames = cx({
    [Styles.input]: true,
    [Styles.readOnly]: readOnly,
    [Styles.disabled]: disabled,
    [Styles.error]: errors && touched
  });

  if (!value && readOnly) { return null; }

  const onKeyPressHandler = (event: any) => {
    if (event.key === 'Enter' && !submitOnEnter) { // Block Enter when submitOnEnter === true
      event.preventDefault();
    } else if (onKeyPress) {
      onKeyPress(event);
    }
  };

  const globalErrorClass = errors && touched ? 'field--error' : '';

  return (
    <Fragment>
      {!readOnly &&
        <div className={componentClassNames}>
          <label htmlFor={id} className={Styles.label}>{required ? `${label}*` : label}</label>
          <input
            // defaultValue={defaultValue}
            {...restProps}
            id={id}
            value={value}
            className={`${textInputClassNames} ${globalErrorClass}`}
            disabled={readOnly || disabled}
            onKeyPress={onKeyPressHandler}
            title={placeholder}
            required={required}
            placeholder={required ? `${placeholder}*` : placeholder}
          />
          {appendIcon && (
            <div className={Styles.appendIcon} title={iconTitle}>
              <img onClick={onAppendIconClick} src={appendIcon} />
            </div>
          )}
          {errors && touched &&  (
            <span className={Styles.errorWrapper}>
              <FieldMessage error={true} message={errors} />
            </span>
          )}
        </div>
      }
      {readOnly && (
        <div className={Styles.readOnly}>{value}</div>
      )}
    </Fragment>
  );
};

export default TextInput;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/TextInput/TextInput.tsx